import React from 'react';

const FarmElement = ({ title, click, view, icon }) => {
  return (
    <button
      onClick={click}
      className={`focus:outline-none px-5 md:px-5 py-3 md:py-5 text-xs md:text-sm lg:text-base ${
        view ? 'text-cf-300' : ''
      }`}
    >
      <span className="md:hidden">{icon}</span>
      <span className="hidden md:block">{title}</span>
    </button>
  );
};

export default FarmElement;
